<template>
    <span>
        <v-select v-if="showEditor" valueKey="id" textKey="name" display="pending" :allowUnset="true" :currentValue="currentValue" :options="locations" @blur="blur" @change="change" ref="el"></v-select>
        <span v-else @click="toggleEdit()" style="cursor: pointer" :style="{backgroundColor: backgroundColor}" class="location tooltip-bottom" :class="{modified: modified}" :data-tooltip="tooltiptext">
            {{ renderLocation }}
        </span>
    </span>
</template>

<script>
    export default {
      data () {
        return {
          newValue: '',
          user_set: false,
          editing: false,
          defaultLocation: 'Loveland'
        }
      },
      created () {
        this.newValue = this.currentValue
      },
      updated() {
          if(this.editing) {
              this.$refs.el.focus();
          }
      },
      props: {
        currentValue: null,
        readonly: undefined
      },
      computed: {
        locations () {
            return this.$privateReactiveStore.getLocations()
        },
        trips () {
            return this.$privateReactiveStore.getTrips()
        },
        goingTo () {
          return this.trips.filter(x => x.active && x.to === this.currentValue).length
        },
        comingFrom () {
          return this.trips.filter(x => x.active && x.from === this.currentValue).length
        },
        tooltiptext () {
          return `${this.comingFrom} departures / ${this.goingTo} arrivals`
        },
        renderLocation () {
          let tmp = this.$privateReactiveStore.getLocation(this.newValue);
          return tmp && tmp.name || this.defaultLocation 
        },
        backgroundColor () {
          if (this.renderLocation === 'KAM') {
            return '#FF4136'
          } else if (this.renderLocation === 'Loveland') {
            return '#DDDDDD'
          } else if (this.renderLocation === 'Reading') {
            return '#FFDC00'
          } else if (this.renderLocation === 'Colerain') {
            return '#2ECC40'
          } else if (this.renderLocation === 'Galbraith') {
            return '#0074D9'
          } else {
            return 'none'
          }
        },
        modified () {
          return this.currentValue !== this.newValue
        },
        showEditor () {
          return (
            this.editing || !this.newValue
          )
        },
      },
      methods: {
        toggleEdit () {
          if (this.readonly !== undefined && this.readonly !== false) {
              return
          }

          this.editing = true
        },
        change (event) {
          this.editing = false
          this.newValue = event
          this.$emit('change', event)
        },
        blur () {
          this.editing = false
        }
      },
      watch: {
        currentValue () {
          if (!this.user_set) {
            this.newValue = this.currentValue
          }
        }
      }
    }
</script>

<style>
    .modified::after {
        content: '...'
    }

    .modified {
        font-style: italic;
    }

    .location {
        font-weight: bold;
        padding: 0.3em;
        border-radius: 5px;
        border: 1px solid white;
    }
</style>